/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { combineReducers } from 'redux';
import { uiReducer } from './ui.reducer';
import { uiNotificationReducer } from './ui-notification.reducer';
import { rolesReducer } from './roles.reducer';
import { settingsReducer } from './settings.reducer';
import { userReducer } from './user.reducer';
import { permissionsReducer } from './permissions.reducer';
import { configReducer } from './config.reducer';
import { initializationReducer } from './initialization.reducer';
import { appConfigReducer } from './appconfig.reducer';

const rootReducer = combineReducers({
  ui: uiReducer,
  notification: uiNotificationReducer,
  roles: rolesReducer,
  settings: settingsReducer,
  user: userReducer,
  permissions: permissionsReducer,
  config: configReducer,
  init: initializationReducer,
  appConfig: appConfigReducer,
});

export default rootReducer;
